import { createSelector } from '@ngrx/store';
import { getOnlineMenuVirtualLocationsPagesFiltered } from '../getOnlineMenuVirtualLocationsPagesFiltered';

export const getOnlineMenuVirtualLocationsProductsFiltered = createSelector(getOnlineMenuVirtualLocationsPagesFiltered, (onlineMenuVirtualLocationsPagesFiltered) =>
    onlineMenuVirtualLocationsPagesFiltered?.reduce((products, page) => [...products, ...page.Products], [] as OLO.DTO.OnlineMenuProductResponseModel[]) || null);
